<template>
  <div id="HomeVue">
    <CommandBar />
    <!-- <button v&#45;on:click="run()" class="btn btn&#45;outline&#45;primary btn&#45;lg"><code> run </code></button> -->
    <div id="cytoContainContain">
      <div id="cytoscapeContainer"></div>
    </div>
  </div>
</template>
<style scoped>

#HomeVue {
  /* width:500px; */
  /* border: 1px solid red; */
  /* background-color: blue; */
}
#cytoContainContain {
  /* position: absolute; */
  /* border: 1px dashed blue; */
  /* background-color: magenta; */
}
#cytoscapeContainer {
  text-align: left; /* essential to have the textaling be left, else there will be a half/screen offset */
  position: absolute;
  /* border: 1px solid green; */
  /* background-color: #eeeeeeff; */
  /* background-color: #606060ff; */
  /* background-color: #707070ff; */
  /*background: linear-gradient( #404060ff, #807070ff);/*blue to purplegray vertical gradient*/
  /* background: linear-gradient( to right, #404040ff, #707070ff); */
  background: radial-gradient( #606060ff, #707070ff, #a0a0a0ff);
  width: 100%;
  /* width: 1000px; */
  height: 1000px;
}
#cytoscapeContainer > div > canvas{
  /* position: relative; */
  /* border: 1px dashed green; */
}

</style>
<script>
import { Component, Vue, Watch} from 'vue-property-decorator';
import store from '@/store/Store';
// import DoNow from '@/components/DoNow.vue'; // @ is an alias to /src
import CommandBar from '@/components/CommandBar';
import * as Graph from '@/common/Graph';
import Task from '@/common/Task';
// import WorkEntry from '@/common/WorkEntry';
import * as DateTime from '@/common/DateTime';

export default
@Component({
  components: {
    CommandBar
  },
})
class Home extends Vue {

  get getWindowTitle(){ //this is necessary for the Watch to work
    // Vue.$log.info('Home.getWindowTitle');
    return store.getters.getWindowTitle;
  }
  @Watch('getWindowTitle') onResultChange(newv,oldv){
    // Vue.$log.info('Home.Watch.getWindowTitle newv' + newv + ' oldv' + oldv);
    this.$title = newv;
  }

  mounted(){
    Vue.$log.debug('Home.vue mounted()');

    Graph.initCytoscape()
      .then( ()=>{
        Graph.drawGraph();
      })
      .catch( (err) => { Vue.$log.info('Home had error', err); } );
  }

  runTest(){
    Vue.$log.debug('Home.vue run()');
    // //object classes
    let dt = DateTime.getNow();
    Vue.$log.info('have date time = ' + DateTime.dateTimeToString(dt), dt);

    // const ta = new Task( 'do thing a', dt, 1.5 );
    // this.$log.info('have task = ' + ta.toString());
    // ta.addWorkEntry( new DateTime( 2019, 1, 2, 8,1,2 ), new DateTime( 2019, 1, 2, 9,2,3 ), 85);
    // ta.printTask();

    let ret = {};

    ret = Graph.addTask( 'do thing a', DateTime.makeDate(2019,2,20), 0.5 );
    if (!ret){ console.log(ret.message); }
    // ret = Graph.addTask( 'do thing a', new DateTime(2019,2,20), 0.5 );
    // if (!ret){ console.log(ret.message); }
    // ret = Graph.addTask( 'do thing a', new DateTime(2019,2,20), 0.5 );
    // if (!ret){ console.log(ret.message); }

    ret = Graph.addTask( 'do thing b', DateTime.makeDate(2019,2,20), 1.5 );
    if (!ret){ console.log(ret.message); }
    ret = Graph.addTask( 'do thing c', DateTime.makeDate(2019,2,20), 1.5 );
    if (!ret){ console.log(ret.message); }
    ret = Graph.addTask( 'do thing d', DateTime.makeDate(2019,2,20), 1.5 );
    if (!ret){ console.log(ret.message); }
    ret = Graph.addTask( 'do thing e', DateTime.makeDate(2019,2,20), 1.5 );
    if (!ret){ console.log(ret.message); }
    ret = Graph.addTask( 'do thing f', DateTime.makeDate(2019,2,20), 1.5 );
    ret = Graph.addTask( 'do thing g', DateTime.makeDate(2019,2,20), 1.5 );
    ret = Graph.addTask( 'do thing h', DateTime.makeDate(2019,2,20), 1.5 );
    ret = Graph.addTask( 'do thing i', DateTime.makeDate(2019,2,20), 1.5 );
    if (!ret){ console.log(ret.message); }

    ret = Graph.addEdge( 'do thing a', 'do thing b' );
    ret = Graph.addEdge( 'do thing b', 'do thing c' );
    ret = Graph.addEdge( 'do thing b', 'do thing d' );
    ret = Graph.addEdge( 'do thing b', 'do thing e' );
    ret = Graph.addEdge( 'do thing a', 'do thing f' );
    ret = Graph.addEdge( 'do thing a', 'do thing g' );
    ret = Graph.addEdge( 'do thing g', 'do thing h' );
    ret = Graph.addEdge( 'do thing f', 'do thing i' );

    // ret = Graph.addEdge( 'do thing b', 'do thing e' );
    // ret = Graph.addEdge( 'do thing a', 'do thing f' );

    // Graph.delTask( 'do thing b' );
    // ret = Graph.delEdge( 'do thing a', 'do thing b' );

    Graph.drawGraph();
    // gp.printTasks();
    ret = Graph.printTasks(); //needs to follow drawGraph so that CY has nodes...
  }


}
</script>
